var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product)?_c(_vm.component,{tag:"component",staticClass:"js-slider-item",class:{
    'is-current': _vm.isCurrentProduct(_vm.product),
    'is-highlighted': _vm.isCurrentArticle(_vm.product),
  },attrs:{"image-type":_vm.imageType,"product":_vm.product,"show-play-product":_vm.showPlayProduct},on:{"highlight-viewport-leave":_vm.onHighlightViewportLeave,"trailer-ended":_vm.onTrailerEnded}}):(_vm.productsArray)?_c('div',{staticClass:"c-tile-two-lines__wrapper js-slider-item"},[_vm._l((_vm.productsArray),function(productItem){return [_c(_vm.component,{key:productItem.id,tag:"component",class:{
        'is-current': _vm.isCurrentProduct(productItem),
        'is-highlighted': _vm.isCurrentArticle(productItem),
      },attrs:{"image-type":_vm.imageType,"product":productItem}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }